// extracted by mini-css-extract-plugin
export default {"input":"input_input__L+c70","disabled":"input_disabled__ABSzZ"};